export default class eventHandler {
	constructor(httpClient, store, events) {
		this.httpClient = httpClient;
		this.store = store;
		this.events = events;
		return this;
	}

	handle(event, data, bus) {
		this.events[event].call(this, {
			bus: bus,
			data: data,
			event: event,
		});
	};

	unshift(module, key, value, id) {
		return this.store.commit(module + "/unshift", {
			key: key,
			value: value,
			id: id,
		});
	}
}
